import { render, staticRenderFns } from "./appointment-list.vue?vue&type=template&id=a5940fb6"
import script from "./appointment-list.vue?vue&type=script&lang=ts"
export * from "./appointment-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports